export default "__VITE_ASSET__CaQB$fkI__"